import { Pipe, PipeTransform } from '@angular/core';
import { GridMode } from '../types/gridmode';

@Pipe({
  name: 'cxShowable',
})
export class CxShowablePipe implements PipeTransform {
  transform(items: any[], ctx: any): any[] {
    const listmode = ctx.gridMode === GridMode.List;
    if (listmode) {
      return items.filter((x: any) => x.display && x.viewable && x.listmode);
    }
    return items.filter((x: any) => x.display && x.viewable);
  }
}
